import React from 'react';
import { Row, Col } from 'reactstrap';
import KeyVisual from '../../../truck/common/KeyVisual';
import Button from '@jobmatchme/ui/es/components/Button';
import Headline from '@jobmatchme/ui/es/components/Headline';
import { useTranslation } from 'react-i18next';
import styles from './style.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SectionKeyVisual = function SectionKeyVisual() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var translateNs = 'landingpage-components:keyvisual';
  return /*#__PURE__*/_jsx(KeyVisual, {
    backgroundClass: styles.background,
    backgroundColor: "dark",
    children: /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        xl: {
          size: 6,
          offset: 3
        },
        md: {
          size: 12,
          offset: 0
        },
        children: [/*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx(Headline, {
              className: styles.headline,
              center: true,
              size: 1,
              color: "white",
              children: /*#__PURE__*/_jsx("span", {
                children: t("".concat(translateNs, ".headline"))
              })
            })
          })
        }), /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx("h2", {
              className: styles.subheader,
              children: t("".concat(translateNs, ".subheader"))
            })
          })
        }), /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            className: styles.ctaSection,
            children: [/*#__PURE__*/_jsx("h3", {
              className: styles.subheader,
              children: t("".concat(translateNs, ".subheader2"))
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Button, {
              id: "cta-pc-landingpage",
              color: "light",
              size: "large",
              variant: "raised",
              link: "https://".concat(process.env.RAZZLE_STAGE === 'prod' ? 'www' : process.env.RAZZLE_STAGE, ".jobmatch.me/de/jobs/fahrer/suche/"),
              title: "Job suchen",
              className: styles.BlueButton,
              children: t("".concat(translateNs, ".calltoaction"))
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
              className: styles.smallLine,
              children: "\xA0"
            })]
          })
        }), /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx(Button, {
              color: "white",
              size: "large",
              variant: "outlined",
              title: "Anmelden",
              link: "https://".concat(process.env.RAZZLE_STAGE === 'prod' ? 'www' : process.env.RAZZLE_STAGE, ".jobmatch.me/de/login/"),
              className: styles.Button,
              children: t("".concat(translateNs, ".login.button"))
            })
          })
        })]
      })
    })
  });
};
export default /*#__PURE__*/React.memo(SectionKeyVisual);